import React, { Fragment } from 'react';
import DocumentTitle from 'react-document-title';

import SocialImpactPage from '../components/company/socialimpact-page/socialimpact-page';

const SocialImpactRoute = () => (
  <Fragment>
    <DocumentTitle title="Social Impact | NerdWallet" />
    <SocialImpactPage />
  </Fragment>
);

SocialImpactRoute.displayName = 'Social Impact Route';
SocialImpactRoute.analyticsName = 'socialimpact_page';

export default SocialImpactRoute;
